import { render, staticRenderFns } from "./SharingDetails.vue?vue&type=template&id=063a6c62"
import script from "./SharingDetails.vue?vue&type=script&lang=js"
export * from "./SharingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports